import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { faTimesCircle, faCheckCircle } from '@fortawesome/pro-regular-svg-icons';

@Component({
  selector: 'app-string-list-item',
  templateUrl: './string-list-item.component.html',
  styleUrls: ['./string-list-item.component.scss']
})
export class StringListItemComponent implements OnInit {
  faTimesCircle = faTimesCircle;
  faCheckCircle = faCheckCircle;

  @Input()
  placeholder: string = "Add an item";

  @Input()
  item: any;

  @Input()
  new = false;

  @Output()
  itemRemoved: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  itemCreated: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  createItem(): void {
    this.itemCreated.emit(this.item);
    this.item = '';
  }

  removeItem(): void {
    this.itemRemoved.emit(this.item);
  }
}
